import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import StepForwardOutlinedSvg from "@ant-design/icons-svg/es/asn/StepForwardOutlined";
import AntdIcon from '../components/AntdIcon';
var StepForwardOutlined = function StepForwardOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(AntdIcon, _objectSpread(_objectSpread({}, props), {}, {
    ref: ref,
    icon: StepForwardOutlinedSvg
  }));
};
var RefIcon = /*#__PURE__*/React.forwardRef(StepForwardOutlined);
if (process.env.NODE_ENV !== 'production') {
  RefIcon.displayName = 'StepForwardOutlined';
}
export default RefIcon;